<template>
    <div>
        <Alerts :alert-type="'alert_homepage'"></Alerts>
        <TaxaPodFetestiNavigation></TaxaPodFetestiNavigation>

        <div class="section d-flex justify-content-center" :class="{'pb-0': isLoggedIn && vehicles}">
            <div class="container container-medium purchase-wrapper">
                <div class="text-center pt-2">
                    <Heading :title="$t('buy_toll')" :routeName="'cart'" :alignment="'text-center'"></Heading>
                    <div><span class="main-text">{{ $tc('step', 1) }}: {{ $t('select_type_of_vehicle') }}</span></div>
                </div>
                <div class="categories" :class="{'mb-0': isLoggedIn && vehicles}">
                    <div class="row mt-4">
                        <div class="col-md-3 col-6 item-card" v-for="(item, key) in tollCategories" :key="key">
                            <router-link :to="{name: 'toll-category', params: {id: item.id}}">
                                <div class="card" dusk="cardelem">
                                    <div class="text-center d-flex img-wrapper">
                                        <div class="cat-icon" :class="icons[key].icon" alt=""></div>
                                    </div>
                                    <div class="card-body text-center align-items-center d-flex justify-content-center">
                                        <p class="card-text"><small class="subtitle" v-html="item.desc"></small></p>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="isLoggedIn">
            <template v-if="vehicles">
                <div class="container container-small">
                    <div class="text-center">
                        <div class="heading heading-small">{{ $t('or_pay_for') }} <router-link :to="{name: 'my-cars'}">{{ $t('your_vehicles_link') }}</router-link></div>
                    </div>
                </div>
                <div class="container container-small">
                    <div class="cart-item my-3 p-2" v-for="(item, key) in vehicles" v-if="item._category_TPF" v-bind:key="key">
                        <AddProductForVehicle :vehicle="item" :type="'toll'"></AddProductForVehicle>
                    </div>
                </div>
                <div class="container container-small text-center" v-if="totalVehiclesPages > 1">
                    <div class="heading heading-small">
                        {{ $t('see_all_your_vehicles') }} <router-link :to="{name: 'my-cars'}">{{ $t('here') }}</router-link>
                    </div>
                </div>
            </template>
        </template>

        <template v-else>
            <div class="login-section">
                <div class="d-flex justify-content-center w-100">
                    <div class="circle">
                        <p class="text">sau</p>
                    </div>
                </div>
                <div class="container container-small">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div class="main-text text-center">{{ $t('or_go_to_your_account_and_buy') }}</div>
                        </div>
                    </div>
                    <LoginComponent></LoginComponent>
                </div>
            </div>
        </template>
        <section class="section-frequent-questions">
            <div class="container container-small">
                <p class="text-center heading-medium">{{ $t('header_how_does_it_work') }}</p>
                <HowItWorks :withTitle="false" :showBoth="'toll'"></HowItWorks>
            </div>
        </section>
        <template v-if="cartCount() && isMobile()">
            <br><br><br>
            <div class="bottom-bar">
                <div class="container text-center pt-2">
                    <CartSummary></CartSummary>
                    <div class="row align-items-center">
                        <div class="col-12">
                            <div class="action-button text-center">
                                <router-link :to="{name: 'cart'}">
                                    <button type="submit" class="btn btn-light">{{ $t('see_cart') }} <i class="fas fa-arrow-right"></i></button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>

import Header from './Header.vue'
import Heading from './snippets/Heading.vue'
import MainNavigation from './MainNavigation.vue'
import TaxaPodFetestiNavigation from './TaxaPodFetestiNavigation.vue'
import CartSummary from './order/CartSummary.vue'
import LoginComponent from './authentication/LoginComponent.vue'
import FrequentQuestionComponent from './FrequentQuestionComponent.vue'
import AddProductForVehicle from './snippets/AddProductForVehicle.vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import HowItWorks from './HowItWorks.vue'
import Alerts from './snippets/Alerts.vue';

export default {
     name: 'Toll',
     components: {
          Header,
          MainNavigation,
          TaxaPodFetestiNavigation,
          CartSummary,
          LoginComponent,
          FrequentQuestionComponent,
          AddProductForVehicle,
          Heading,
          HowItWorks,
          Alerts
     },
     props: {
     },
     computed: {
         ...mapState('vehicles', {
             vehicles: 'vehicles'
         }),

         ...mapState('tollCategories', {
             tollCategories: 'categories',
             icons: 'icons'
         }),

         ...mapState('auth', [
             'isLoggedIn'
         ]),
     },
     data: function() {
         return {
             count: 5,
             showMoreBtn: true,
             totalVehiclesPages: 0
         }
     },
     mounted() {
         this.init();
     },
     methods: {

         ...mapActions('tollCategories', {
             getTollCategories: 'getCategories'
         }),

         ...mapActions('vehicles', [
             'getVehicles'
         ]),

         ...mapGetters('auth', [
             'getLoginStatus'
         ]),

         async init() {
             this.loading = true;

             try {
                 await this.getTollCategories();

                 if(this.getLoginStatus()) {
                    let response = await this.getVehicles();
                    this.totalVehiclesPages = response.data.data.vehicles_total;
                 }

                 this.loading = false;
             } catch (e) {
                 console.log(e);
             }
         },
         cartCount() {
             return this.$store.state.cart.length;
         },
        showMore() {
            this.count = 100;
            this.showMoreBtn = false;
        }
     }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    $lightgrey: lightgrey;
    $green: #59af54;

    .cat-icon {
        height: 75px;
    }

    .container {
        .border-right {
            border-right: 1px solid #C7C7C6;
        }
    }

    .section {
        background-color: #FAF9F6;
        background-position: center;
        background-size: cover;
        padding-bottom: 50px;
        .purchase-wrapper {
            margin-top: 40px;
            margin-bottom: 30px;
        }
    }
    .card-valability {
        cursor: pointer;
    }
    .card {
        position: relative !important;
        border: 1px solid;
        border-color: #0F2443;
        border-radius: 3px !important;
        text-align: initial;
        padding: 10px;
        span {

            font-weight: bold;
            font-size: 22px;
        }
        .margin-minus{
            top: -14px;
            right: -16px;
        }
        &:hover{
            padding: 8px;
            border: 3px solid;
            border-
            .margin-minus{
                top: -14px;
                right: -16px;
            }
        }
    }

    .circle {
        margin: -50px auto;
        width: 75px;
        height: 75px;
        border-radius: 50%;
        background-color: #0F2443;
        position: absolute;
        top: 10px;
    }
    .text {
        font-size: 18px;
        font-weight: bold;
        color: white;
        text-align: center;
        padding-top: 24.5px;
    }
</style>
